import { ReactNode } from 'react'
import isObject from 'lodash/isObject'
import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'

import { getColumnFieldNameForSort } from '@pages/ConfiguredEntity/helpers'

import { isNotEmpty } from '@helpers'
import { BIND_TYPE, FIELD_VALUE_FORMAT, FIELD_VALUE_TYPE, OBJECT_FIELD_TYPE } from '@constants'
import { CellRendererFunctionType, EnumCellType, ObjectDataRecord } from '@types'

import { isObjectValueType } from '../isObjectValueType'

import {
  renderBooleanValueCell,
  renderDateTimeValueCell,
  renderEnumCell,
  renderIntegerAsTimeValueCell,
  renderJSValueCell,
  renderJSXValueCell,
  renderMappedCheckboxCell,
  renderObjectEmbeddedCell,
} from './index'

const renderDefaultCell = (
  code: string,
  params: GridRenderCellParams<unknown, ObjectDataRecord, unknown>
): ReactNode => {
  const value = params.row?.[code]

  if (value && typeof value === 'object') {
    return value.label ?? ''
  }

  return isNotEmpty(value) ? value : ''
}

export const cellRenderer: CellRendererFunctionType = (column, params, dialogId) => {
  const asCheckbox =
    column.valueFormat === FIELD_VALUE_FORMAT.NUMBER ||
    column.valueFormat === FIELD_VALUE_FORMAT.BOOLEAN

  const renderCheckboxCell = asCheckbox && column.valueFormat

  if (column.fieldType === OBJECT_FIELD_TYPE.ARRAY) {
    if (Array.isArray(params.value)) {
      return params.value.map(opt => opt.label).join(', ')
    }

    if (isObject(params.value)) {
      return Object.values(params.value as Record<string, any>).join(', ')
    }

    return null
  }

  if (
    (column.valueType === FIELD_VALUE_TYPE.DATETIME ||
      (column.pathArray?.length &&
        column.pathArray[column.pathArray.length - 1]?.valueType === FIELD_VALUE_TYPE.DATETIME)) &&
    column.formatDate
  ) {
    return renderDateTimeValueCell(params.row[column.code], column.formatDate)
  }

  if (renderCheckboxCell) {
    return renderMappedCheckboxCell(column.code, column.valueFormat, params)
  }

  if (column.bindType === BIND_TYPE.JSX && column.value) {
    return renderJSXValueCell(column.value, params.row)
  }
  if (column.bindType === BIND_TYPE.JS && column.value) {
    return renderJSValueCell(column.value, params.row)
  }
  if (isObjectValueType(column.valueType) && column.objectValue) {
    return renderObjectEmbeddedCell(
      column.code,
      // column.objectValue,
      params.row
    )
  }
  if (column.valueType === FIELD_VALUE_TYPE.BOOLEAN) {
    return renderBooleanValueCell(params.row[column.code] ?? '')
  }

  if (
    column.valueType === FIELD_VALUE_TYPE.INTEGER &&
    column.valueFormat === FIELD_VALUE_FORMAT.TIME
  ) {
    return renderIntegerAsTimeValueCell(column.code, params)
  }

  if (column.fieldType === OBJECT_FIELD_TYPE.ENUM && column.enumDescription && column.objectCode) {
    const dataEnumCell: EnumCellType = {
      isDialogWindow: Boolean(dialogId),
      name: getColumnFieldNameForSort(column),
      objectCode: column.objectCode,
      value: params.row[column.code],
      valueType: column.valueType,
    }

    return renderEnumCell(dataEnumCell) as ReactNode
  }

  return renderDefaultCell(column.code, params)
}
